document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.panal-entry [data-panal-modal]');
  const steps = Array.from(document.querySelectorAll('.panal-entry .panal-step'));
  const externalOpenButtons = document.querySelectorAll('[data-open-panal-experience]');
  const closeButtons = document.querySelectorAll('.panal-entry [data-panal-close]');
  const nextButtons = document.querySelectorAll('.panal-entry [data-next-step]');
  const prevButtons = document.querySelectorAll('.panal-entry [data-prev-step]');
  const clearSignatureButton = document.querySelector('.panal-entry [data-clear-signature]');
  const canvas = document.querySelector('.panal-entry [data-signature-canvas]');
  const signatureOutput = document.querySelector('.panal-entry [data-signature-output]');
  const submitButton = document.querySelector('.panal-entry [data-submit-panal]');

  if (!modal || !steps.length) return;

  const WEBHOOK_URL = 'TU_WEBHOOK_URL_AQUI';
  let currentStep = 0;

  const showStep = (index) => {
    steps.forEach((step, stepIndex) => {
      step.classList.toggle('is-active', stepIndex === index);
    });
    currentStep = index;
  };

  const openModal = () => {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    showStep(0);
  };

  const closeModal = () => {
    modal.hidden = true;
    document.body.style.overflow = '';
  };

  const getValue = (name) => {
    const input = document.querySelector(`.panal-entry [name="${name}"]`);
    return input ? input.value.trim() : '';
  };

  const getCheckedValue = (name) => {
    const input = document.querySelector(`.panal-entry [name="${name}"]:checked`);
    return input ? input.value : '';
  };

  const getCheckedValues = (name) => {
    return Array.from(document.querySelectorAll(`.panal-entry [name="${name}"]:checked`)).map((input) => input.value);
  };

  const collectPayload = () => ({
    id: `${Date.now()}`,
    full_name: getValue('full_name'),
    email: getValue('email'),
    venture_name: getValue('venture_name'),
    current_stage: getCheckedValue('current_stage'),
    current_focus: getValue('current_focus'),
    panal_needs: getCheckedValues('panal_needs'),
    wants_updates: getCheckedValue('wants_updates'),
    signature_data: signatureOutput ? signatureOutput.value : '',
    instagram_url: 'https://www.instagram.com/tst_bags/',
    instagram_url: 'https://www.instagram.com/the_secondtime_/'
  });

  externalOpenButtons.forEach((button) => {
    button.addEventListener('click', openModal);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  nextButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (currentStep < steps.length - 1) {
        showStep(currentStep + 1);
      }
    });
  });

  prevButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (currentStep > 0) {
        showStep(currentStep - 1);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  if (canvas && signatureOutput) {
    const context = canvas.getContext('2d');
    let drawing = false;

    const setupContext = () => {
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.lineWidth = 2.5;
      context.strokeStyle = '#6b4b35';
    };

    const resizeCanvas = () => {
      const ratio = window.devicePixelRatio || 1;
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * ratio;
      canvas.height = rect.height * ratio;
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.scale(ratio, ratio);
      setupContext();
    };

    const getPosition = (event) => {
      const rect = canvas.getBoundingClientRect();

      if (event.touches && event.touches[0]) {
        return {
          x: event.touches[0].clientX - rect.left,
          y: event.touches[0].clientY - rect.top
        };
      }

      return {
        x: event.clientX - rect.left,
        y: event.clientY - rect.top
      };
    };

    const startDrawing = (event) => {
      drawing = true;
      const position = getPosition(event);
      context.beginPath();
      context.moveTo(position.x, position.y);
    };

    const draw = (event) => {
      if (!drawing) return;
      event.preventDefault();
      const position = getPosition(event);
      context.lineTo(position.x, position.y);
      context.stroke();
      signatureOutput.value = canvas.toDataURL('image/png');
    };

    const stopDrawing = () => {
      drawing = false;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    canvas.addEventListener('mousedown', startDrawing);
    canvas.addEventListener('mousemove', draw);
    canvas.addEventListener('mouseup', stopDrawing);
    canvas.addEventListener('mouseleave', stopDrawing);

    canvas.addEventListener('touchstart', startDrawing, { passive: false });
    canvas.addEventListener('touchmove', draw, { passive: false });
    canvas.addEventListener('touchend', stopDrawing);

    if (clearSignatureButton) {
      clearSignatureButton.addEventListener('click', () => {
        context.clearRect(0, 0, canvas.width, canvas.height);
        setupContext();
        signatureOutput.value = '';
      });
    }
  }

  if (submitButton) {
    submitButton.addEventListener('click', async () => {
      const payload = collectPayload();

      submitButton.disabled = true;
      submitButton.textContent = 'Enviando...';

      try {
        await fetch(WEBHOOK_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        showStep(5);
      } catch (error) {
        alert('No pudimos guardar tu entrada al Panal. Inténtalo de nuevo.');
        console.error(error);
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = 'Finalizar mi entrada';
      }
    });
  }
});
